import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section
      id="home"
      className="bg-white min-h-[85vh] flex items-center justify-center py-20 hero bg-gradient-to-b from-[#f3f3f1] to-[#eae9e4]"
    >
      <div className="max-w-5xl mx-auto px-4 text-center flex flex-col items-center ">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex items-center justify-center gap-2 mb-6 px-5 py-1.5 font-bold bg-beige rounded-full text-earth"
        >
          <span className="h-2.5 w-2.5 rounded-full bg-primary shadow-[0_0_8px_rgba(29,78,216,0.6)]"></span>

          Welcome to Interlink
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className=" md:text-7xl sm:text-5xl text-4xl font-semibold text-dark leading-tight"
        >
          <div>
          Where <span className="text-accent font-playfair font-semibold italic">Curiosity</span></div><div> Becomes{" "}
          <span className="text-primary font-raleway font-bold">Creation</span></div>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="mt-6 text-lg md:text-2xl text-dark/80 max-w-3xl mx-auto"
        >
          Build real projects. Share your skills. Shape what’s next.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <a
            href="#join"
            className="inline-block mt-8 bg-primary text-white font-medium px-8 py-3 rounded-lg shadow-md hover:opacity-90 hover:-translate-y-0.5 transition-all"
          >
            Join Interlink
          </a>
        </motion.div>
      </div>
    </section>
  );
}
